<div app-sidenav>
  <h1 class="text-3xl text-theme-950">
    {{ labelUcIvca | translate }}
  </h1>
  <div class="relative">
    <h4 class="pb-4 pt-8 text-lg text-theme-800" translate>breadcrumb.estudio.titulo</h4>
    <div class="relative rounded-md shadow-sm">
      <input
        app-input
        class="block leading-5"
        type="text"
        [placeholder]="'trilhas.estudio.pesquisar' | translate"
        [formControl]="search"
      />
      <div class="absolute inset-y-0 right-0 flex items-center pr-3">
        <svg-icon
          class="flex h-5 w-5 text-theme-500 group-hover:text-theme-contrast"
          src="assets/icons/icon-search.svg"
        ></svg-icon>
      </div>
    </div>
  </div>

  <ng-container *ngIf="categories$ | async as categories">
    <div class="flex items-center justify-between pb-4 pt-10">
      <h4 class="text-lg text-theme-800" translate>trilhas.estudio.categorias</h4>
      <button
        type="button"
        (click)="onShowAll()"
        class="ml-2 w-36 rounded-full border px-1 hover:bg-theme-600 hover:text-theme-50"
        [ngClass]="{ 'bg-theme-600 text-theme-50': allFilteredCategories }"
      >
        <div class="flex items-center justify-between">
          <p class="w-3/4 border-r border-theme-50 text-center text-md" translate>trilhas.curso.ver-todos</p>
          <p class="w-1/4 pl-1 text-center text-md">{{ countAllCourses }}</p>
        </div>
      </button>
    </div>
    <div class="no-scrollbar h-[calc(100%-20rem)] overflow-y-auto">
      <button
        *ngFor="let category of categories"
        (click)="onFilterCollection(category.id)"
        type="button"
        class="mb-2 h-20 w-full rounded-xl border px-5 py-2 shadow-md duration-300 hover:bg-theme-300 hover:text-theme-50"
        [ngClass]="{ 'bg-theme-500 text-theme-50': isSelected(category.id) || allFilteredCategories }"
      >
        <div class="flex items-center">
          <p class="w-11/12 text-left text-lg font-semibold">{{ category.nome }}</p>
          <div class="w-1/12">
            <div class="flex h-8 w-8 items-center justify-center rounded-full bg-theme-100 text-theme-400">
              {{ category.numberCourses }}
            </div>
          </div>
        </div>
      </button>
    </div>
  </ng-container>
</div>
